import Dexie from 'dexie'

export const pubhubIndexedDb = new Dexie('pubhubDb')

pubhubIndexedDb.version(1).stores({
  publications: 'ditaId' // Primary key and indexed props
})

export const findCachedPublicationInLanguage = async (ditaId, language) => {
  if (!ditaId) return undefined

  const current = await pubhubIndexedDb.publications.get(ditaId)
  const publication = current?.publicationFromApi
  if (!publication) return undefined

  return pubhubIndexedDb.publications
    .filter(
      ({ publicationFromApi: candidate }) =>
        candidate?.language === language &&
        ['brand', 'model', 'year', 'publicationType'].every(key => candidate[key] === publication[key]) &&
        (candidate.modelType || '') === (publication.modelType || '')
    )
    .first()
}
